import type { GlobalApiPaymentDetails } from '@data/global-api-payments';

export const shouldPollPaymentDetails = (
  paymentDetails: GlobalApiPaymentDetails | null
) => {
  if (paymentDetails?.paymentInitiationFlow.status === 'PROCESSING') {
    return [
      'AWAITING_REDIRECT_URL',
      'AWAITING_DECOUPLED_AUTHORISATION',
    ].includes(paymentDetails.paymentInitiationFlow.details?.reason as string);
  }

  return false;
};
